import hasAddresses from './utilities/hasAddresses';
import hasPhones from './utilities/hasPhones';
import hasTimezone from './utilities/hasTimezone';

const department = (departmentJson) => {
  const properties = {
    ...departmentJson.attributes,
    guid: departmentJson.guid,
  };
  return Object.assign(
    properties,
    hasAddresses(departmentJson.attributes.addresses),
    hasPhones(departmentJson.attributes.phones),
    hasTimezone(departmentJson.attributes.timezone),
  );
};

export default department;
